/**
 * Created by weijianli on 16/11/2.
 */
function browserVersion() {
  var u = navigator.userAgent;
  var ua={
    mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/Mobile/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
    app: u.indexOf('kadaiApp') != -1, //是否为web应用程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') != -1,
    isLiCai: /\syingztApp\//.test(u),
    isKaDai: /\skadaiApp\//.test(u),
    isWallet: /\scom\.xiaoying\.wallet\//.test(u),
    isInstallment:  /com.xiaoying.(beijing\.)?installment/mg.test(u),
    isPuHui: /phApp|puhuiApp|phapp/.test(u),
    isBdtb:/bdtb/.test(u) || /TBClient/.test(u),
    isPc:!/(iPhone|iPod|Android|ios|iPad)/i.test(u),
    isWeibo:/_weibo_/i.test(u),
    isQQ:/\sQQ\//.test(u),
    isWxwork:/\swxwork\//.test(u),
    isSafari:/(iPhone\sOS)\s([\d_]+)([\s\S.]*)(\sSafari\/\d+\.\d)$/.test(u),
    isXYFQ:/com.xfin.(beijing\.)?installment/mg.test(u)
  };
  ua.isBjAPP=ua.isPuHui||ua.isWallet||ua.isKaDai||ua.isInstallment||ua.isXYFQ||false
  ua.isAPP=ua.isBjAPP||ua.isLiCai||false
  return ua
};
export default browserVersion;




// WEBPACK FOOTER //
// ./node_modules/bjxy-common/helper/getBrowserInfo.js